//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        accountAdjustment?: null | undefined | boolean;
        customerId: string;
        from?: null | undefined | string;
        page: number;
        perPage: number;
        statuses?: null | undefined | Array<string>;
        to?: null | undefined | string;
        transactionType: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/all-transactions -> post -> ${code}`);
    };
};

export const Response200IO = t.interface({
    operatorCurrency: t.string,
    results: t.array(t.interface({
        amount: t.string,
        assetFlows: t.array(t.interface({
            balanceAfter: t.string,
            balanceDelta: t.string,
            currency: t.string,
            date: t.string,
            description: t.union([t.null, t.undefined, t.string]),
            externalId: t.union([t.null, t.undefined, t.string]),
            id: t.number,
            type: t.string,
        })),
        balanceDelta: t.string,
        createdAt: t.string,
        currency: t.string,
        currencyRateAtCreation: t.number,
        currencyRateAtFinalization: t.union([t.null, t.undefined, t.number]),
        details: t.interface({
            assignee: t.union([t.null, t.undefined, t.interface({
                id: t.number,
                name: t.string,
                type: t.string,
            })]),
            automaticWithdrawal: t.union([t.null, t.undefined, t.string]),
            cacheToken: t.union([t.null, t.undefined, t.string]),
            category: t.union([t.null, t.undefined, t.string]),
            competition: t.union([t.null, t.undefined, t.string]),
            description: t.union([t.null, t.undefined, t.string]),
            displayedReason: t.union([t.null, t.undefined, t.string]),
            event: t.union([t.null, t.undefined, t.string]),
            expiry: t.union([t.null, t.undefined, t.string]),
            id: t.union([t.null, t.undefined, t.number]),
            internalReason: t.union([t.null, t.undefined, t.string]),
            paymentMethod: t.union([t.null, t.undefined, t.interface({
                expires: t.union([t.null, t.undefined, t.string]),
                id: t.union([t.null, t.undefined, t.string]),
                lastUsedAt: t.union([t.null, t.undefined, t.string]),
                name: t.union([t.null, t.undefined, t.string]),
                number: t.union([t.null, t.undefined, t.string]),
                provider: t.union([t.null, t.undefined, t.string]),
                providerReference: t.union([t.null, t.undefined, t.string]),
                subtype: t.union([t.null, t.undefined, t.string]),
                type: t.union([t.null, t.undefined, t.string]),
            })]),
            rewardType: t.union([t.null, t.undefined, t.string]),
            selection: t.union([t.null, t.undefined, t.string]),
            serverTransId: t.union([t.null, t.undefined, t.string]),
            sport: t.union([t.null, t.undefined, t.string]),
        }),
        finalized: t.boolean,
        finalizedAt: t.union([t.null, t.undefined, t.string]),
        fundsLocked: t.string,
        id: t.number,
        operatorAmount: t.string,
        operatorBalanceDelta: t.string,
        operatorPayout: t.union([t.null, t.undefined, t.string]),
        operatorProfit: t.union([t.null, t.undefined, t.string]),
        operatorTotalAmount: t.string,
        payout: t.union([t.null, t.undefined, t.string]),
        profit: t.union([t.null, t.undefined, t.string]),
        status: t.string,
        tags: t.interface({
            accountAdjustment: t.union([t.null, t.undefined, t.boolean]),
            adjustmentType: t.union([t.null, t.undefined, t.string]),
            tradingAdjustment: t.union([t.null, t.undefined, t.boolean]),
        }),
        totalAmount: t.string,
        type: t.string,
        updatedAt: t.union([t.null, t.undefined, t.string]),
        url: t.string,
    })),
});
export type Response200Type = {
    operatorCurrency: string;
    results: Array<{
        amount: string;
        assetFlows: Array<{
            balanceAfter: string;
            balanceDelta: string;
            currency: string;
            date: string;
            description?: null | undefined | string;
            externalId?: null | undefined | string;
            id: number;
            type: string;
        }>;
        balanceDelta: string;
        createdAt: string;
        currency: string;
        currencyRateAtCreation: number;
        currencyRateAtFinalization?: null | undefined | number;
        details: {
            assignee?: null | undefined | {
                id: number;
                name: string;
                type: string;
            };
            automaticWithdrawal?: null | undefined | string;
            cacheToken?: null | undefined | string;
            category?: null | undefined | string;
            competition?: null | undefined | string;
            description?: null | undefined | string;
            displayedReason?: null | undefined | string;
            event?: null | undefined | string;
            expiry?: null | undefined | string;
            id?: null | undefined | number;
            internalReason?: null | undefined | string;
            paymentMethod?: null | undefined | {
                expires?: null | undefined | string;
                id?: null | undefined | string;
                lastUsedAt?: null | undefined | string;
                name?: null | undefined | string;
                number?: null | undefined | string;
                provider?: null | undefined | string;
                providerReference?: null | undefined | string;
                subtype?: null | undefined | string;
                type?: null | undefined | string;
            };
            rewardType?: null | undefined | string;
            selection?: null | undefined | string;
            serverTransId?: null | undefined | string;
            sport?: null | undefined | string;
        };
        finalized: boolean;
        finalizedAt?: null | undefined | string;
        fundsLocked: string;
        id: number;
        operatorAmount: string;
        operatorBalanceDelta: string;
        operatorPayout?: null | undefined | string;
        operatorProfit?: null | undefined | string;
        operatorTotalAmount: string;
        payout?: null | undefined | string;
        profit?: null | undefined | string;
        status: string;
        tags: {
            accountAdjustment?: null | undefined | boolean;
            adjustmentType?: null | undefined | string;
            tradingAdjustment?: null | undefined | boolean;
        };
        totalAmount: string;
        type: string;
        updatedAt?: null | undefined | string;
        url: string;
    }>;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyStaffAllTransactionsGetListRequest"
 */
export const openapi_proxy_staff_all_transactions_get_list = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/staff/all-transactions${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyStaffAllTransactionsGetListParamsType = ParamsType;

export type OpenapiProxyStaffAllTransactionsGetListResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyStaffAllTransactionsGetListResponse200Type = Response200Type;

export const openapiProxyStaffAllTransactionsGetListRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyStaffAllTransactionsGetListResponseType> => {
    const response = await openapi_proxy_staff_all_transactions_get_list(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffAllTransactionsGetListRequest - unhandled response ${response.status}`);
};

